import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

@Injectable()
export class PromotionService {
    private _promotionSecondsRemaining = new Subject<number>();
    promotionSecondsRemaining = new Observable<number>();

    counter$: Observable<number>;
    timeRemaining: number = 0;
    timerSubscription: Subscription;

    // Promotion-specific variables
    // - Set these to null for no-promotion
    // - The Month is zero-indexed in Date.UTC)
    saleEnd: Date = new Date(Date.UTC(2018, 7, 25, 7, 0, 0));
    // saleEnd: Date = null;
    saleDurationSeconds: number = 60 * 60 * (24 * 3 + 3);
    // saleDurationSeconds: number = null;

    constructor(private readonly router: Router) {
        this.promotionSecondsRemaining = this._promotionSecondsRemaining.asObservable();
        if (this.saleEnd) {
            this.startTimer();
        }
    }

    clear(): void {
        this._promotionSecondsRemaining.next(0);
    }

    isActivePromotion(): boolean {
        return this.timeRemaining > 0;
    }
    
    private startTimer(): void {
        this.timeRemaining = Math.floor((this.saleEnd.getTime() - new Date().getTime()) / 1000);

        if (this.timeRemaining > 0) {
            this._promotionSecondsRemaining.next(this.timeRemaining);
            this.counter$ = Observable.interval(1000).map((x) => {
               return Math.floor((this.saleEnd.getTime() - new Date().getTime()) / 1000);
            });

            this.timerSubscription = this.counter$.subscribe((x) => {
                this.timeRemaining = x;
                if (this.timeRemaining > this.saleDurationSeconds) {
                    this._promotionSecondsRemaining.next(0);
                } else {
                    this._promotionSecondsRemaining.next(this.timeRemaining);
                }
            });
        } else {
            this._promotionSecondsRemaining.next(0);
        }
     }
}



// WEBPACK FOOTER //
// ./src/app/_services/promotion.service.ts